module.exports = __webpack_public_path__ + "img/service-1.86fb0319.png";